import { CancellationToken } from "async/CancellationToken";

export class ShowRemoveSceneParams {
    public readonly buildingId: string;
    public readonly orderID: string;
    public readonly cancellationToken: CancellationToken;

    public constructor(
        buildingId: string,
        orderID: string,
        cancellationToken: CancellationToken
    ) {
        this.buildingId = buildingId;
        this.orderID = orderID;
        this.cancellationToken = cancellationToken;
    }
}
